import { signOutAndRedirectToSignIn } from '~/shared/apollo-queries';
import { PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';

export const changeAuthStatus = ({
  isSignOut,
  isStayOnPage,
  rootContext,
  router,
  lng,
  isClientsPanel,
}: {
  isSignOut: boolean;
  isStayOnPage: boolean;
  rootContext;
  router;
  lng;
  isClientsPanel;
}) => {
  if (isSignOut) {
    signOutAndRedirectToSignIn(isClientsPanel);
  }

  if (!isStayOnPage) {
    router.push(getLocaleLink(isClientsPanel ? PAGE_NAMES.CLIENTS_SIGN_IN : PAGE_NAMES.SIGN_IN, lng));
  }
};
